























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import vueformmodel from "../../../lib/vueformmodel";
import { FormItem } from "view-design";
@Component
export default class suppliermanageaddoredit extends vueformmodel {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop() id: number | undefined;
  model: proxy.ChannelSupplierOutDto = new proxy.ChannelSupplierOutDto();
  ctypes: any[] = [];
  apitypes: any[] = [];
  get prox() {
    return new proxy.ChannelSupplierServiceProxy();
  }

  yufutzPage = {
    pageSize: 20,
    pageNumber: 1,
    totalPages: 1,
    totalItems: 1,
    sorting: undefined,
    pagesizeopts: [10, 20, 30],
    isTableLoading: false,
    dataList: [],
    totalAmount: 0,
    input: new proxy.ChannelAdvanceMoneyAdjustOrderPageInputDto(),
    columns: [
      {
        type: "index",
        width: 60,
        align: "center",
      },
      {
        title: '调整单号',
        key: 'orderNo'
      },
      {
        title: "调整金额",
        key: "money",
      },
      {
        title: "调整原因",
        key: "comment",
      },
      {
        title: "日期",
        slot: "creationTime",
      },
    ],
  };
  pagesizeChange(data, page, t) {
    data.pageSize = page;
    switch (t) {
      case 3:
        this.yufutzPageNumberChange(data.pageNumber);
        break;
    }
  }
  yufutzPageNumberChange(page: number) {
    this.yufutzPage.isTableLoading = true;
    this.yufutzPage.input.maxResultCount = this.yufutzPage.pageSize;
    this.yufutzPage.input.skipCount = (page - 1) * this.yufutzPage.pageSize;
    this.yufutzPage.input.channelId = this.id || 0;
    new proxy.ChannelAdvanceMoneyAdjustOrderServiceProxy().queryModelList(this.yufutzPage.input).then((x) => {
      this.yufutzPage.isTableLoading = false;
      this.yufutzPage.dataList = x.items;
      this.yufutzPage.totalItems = x.totalCount;
      this.yufutzPage.totalPages = Math.ceil(
        x.totalCount / this.yufutzPage.pageSize
      );
    });
  }
  save() {
    (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.prox.createOrUpdate(this.model).then(() => {
          (this.$refs.roleForm as any).resetFields();
          this.$Notice.success({ title: "保存成功" });
          this.$emit("save-success");
          this.$emit("input", false);
        });
      }
    });
  }

  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.prox.queryModel(this.id).then((x) => {
        this.model = x;
        if (!this.model.settlementTime) {
          this.model.settlementTime = '23:59:59';
        }
        this.yufutzPageNumberChange(1);
      });
      let req2 = new proxy.AgentPageInputDto();
      req2.status = 0;
      req2.maxResultCount = 100;
    }
  }

  roleRule = {
    suppName: [
      {
        required: true,
        message: this.L("FieldIsRequired"),
        trigger: "blur",
      },
    ],
  };
}
